export default __webpack_public_path__ + "static/media/check.0adf4d33.svg";